import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const TutoringSessionEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Session Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="sessionNumber" label="Session Number" fullWidth />
        <TextInput source="studentId" label="Student ID" fullWidth />
        <TextInput source="tutorId" label="Tutor ID" fullWidth />
        <TextInput source="scheduleId" label="Schedule ID" fullWidth />
        <TextInput source="subject" fullWidth />
        <TextInput source="sessionDate" type="date" fullWidth />
        <TextInput source="startTime" label="Start Time" fullWidth />
        <TextInput source="endTime" label="End Time" fullWidth />
        <SelectInput
          source="status"
          choices={['Draft', 'Scheduled', 'Confirmed', 'Completed', 'Cancelled', 'Rescheduled'].map(s => ({ id: s, name: s }))}
          fullWidth
        />
      </Box>
      <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Session Notes</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <TextInput source="topicsCovered" label="Topics Covered" multiline rows={3} fullWidth />
        <TextInput source="tutorNotes" label="Tutor Notes" multiline rows={3} fullWidth />
        <TextInput source="homeworkAssigned" label="Homework Assigned" multiline rows={3} fullWidth />
      </Box>
    </SimpleForm>
  </Edit>
);
